import {useState,useEffect} from 'react'
import useMarkAction from '../../../../hooks/useMarkAction'
import util from "../../../../utils/utils";

export const FoldFormModal = (props) => {
    const {foldData, successAction} = props 
    const [nameEmptyAlert, setNameEmptyAlert] = useState(false)
    const {createSavedFoldLoading, createSavedFoldAction, updateSavedFoldInfoLoading, updateSavedFoldInfoAction} = useMarkAction()
    const [foldName, setFoldName] = useState('')
    const [foldDescription, setFoldDescription] = useState('')
    const confirmAction = (event) => {
        event.preventDefault();
        var form = document.getElementById('myFoldForm')        
        const name = form.elements['fold_name'].value;
        const des = form.elements['fold_description'].value;
        // console.log(name, des)
        if(name){
            setNameEmptyAlert(false)
            if(foldData){
                const params = {fold_id:foldData?.fold_id,new_fold_name:name,new_fold_description:des,original_fold_name:foldData?.fold_name,original_fold_description:foldData?.fold_description}
                updateSavedFoldInfoAction(params).then(res=>{
                    if(res){
                        util.showToast('  ✓ 修改成功')
                        reset();
                        successAction()
                    }
                })
            }else{
                const params = {fold_name:name,fold_description:des}
                createSavedFoldAction(params).then(res=>{
                    if(res){
                        util.showToast('  ✓ 创建成功')
                        reset();successAction()
                    }
                })
            }
        }else{
            setNameEmptyAlert(true)
        }
    }
    const nameOnChange = (event) => {
        const name = event.target.value
        setFoldName(name)
        if(name){
            setNameEmptyAlert(false)
        }else{
            setNameEmptyAlert(true)
        }
    }
    const descriptionOnChange = (event) => {
        const description = event.target.value
        setFoldDescription(description)
    }
    const reset = () => {
        setNameEmptyAlert(false);
        if(!foldData){
            setFoldDescription('');setFoldName('')
        }
    }
    useEffect(()=>{
        setFoldName(foldData?.fold_name ?? '')
        setFoldDescription(foldData?.fold_description ?? '')
    },[foldData])

    return (
        <dialog id="my_fold_form_modal" className="modal">
            <div className="modal-box p-0">
                <div className="bg-white p-4 sticky top-0">
                    <div className="flex space-between items-center">
                        <h2 className="card-title pl-4">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" />
                            </svg>
                            {foldData ? '修改' : '新建'}收藏夹
                        </h2>
                        <form method="dialog">
                            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" onClick={()=>{reset()}}>✕</button>
                        </form>
                    </div>
                </div>
                <div className='px-8 pt-2 pb-6'>
                    <form id='myFoldForm'>
                        <input name='fold_name' type="text" placeholder="文件夹名称" value={foldName} className={`input input-bordered w-full ${nameEmptyAlert ? '' : 'mb-4'}`} onChange={nameOnChange}/>
                        {nameEmptyAlert && <div className="label">
                            <span className="label-text-alt text-red-500">请输入文件夹名称！</span>
                        </div>}
                        <textarea name='fold_description' className="textarea textarea-bordered w-full mb-4" placeholder="文件夹描述（可选）" value={foldDescription}  onChange={descriptionOnChange}></textarea>
                        <div className="card-actions justify-center">
                            <button className="btn btn-ghost w-24" type='reset' onClick={()=>{reset();document.getElementById('my_fold_form_modal').close()}}>取消{foldData ? '修改' : '新建'}</button>
                            <button className='btn btn-outline w-24' type='submit' onClick={confirmAction}>
                                {(createSavedFoldLoading || updateSavedFoldInfoLoading) ? <span className="loading loading-spinner"></span> : `确认${foldData ? '修改' : '新建'}`}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={()=>{reset()}}>close</button>
            </form>
        </dialog>
    )
}